import { Control } from 'react-hook-form'
import {
	FormControl,
	FormField,
	FormItem,
	FormLabel,
	FormMessage,
} from '@/common/ui/form'
import { Input } from '@/common/ui/input'
import { Textarea } from '@/common/ui/textarea'
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from '@/common/ui/select'
import { ICON_OPTIONS } from '../constants'
import type { NotificationItemFormData } from '../types'

interface BasicFieldsProps {
	control: Control<NotificationItemFormData>
}

export default function BasicFields({ control }: BasicFieldsProps) {
	return (
		<>
			<FormField
				control={control}
				name="displayName"
				render={({ field }) => (
					<FormItem>
						<FormLabel required>ชื่อที่แสดง</FormLabel>
						<FormControl>
							<Input {...field} placeholder="เช่น คืนยอดเสีย 10%" />
						</FormControl>
						<FormMessage />
					</FormItem>
				)}
			/>

			<FormField
				control={control}
				name="icon"
				render={({ field }) => (
					<FormItem>
						<FormLabel>ไอคอน</FormLabel>
						<Select value={field.value} onValueChange={field.onChange}>
							<FormControl>
								<SelectTrigger>
									<SelectValue placeholder="เลือกไอคอน" />
								</SelectTrigger>
							</FormControl>
							<SelectContent>
								{ICON_OPTIONS.map((icon) => (
									<SelectItem key={icon.value} value={icon.value}>
										{icon.label}
									</SelectItem>
								))}
							</SelectContent>
						</Select>
						<FormMessage />
					</FormItem>
				)}
			/>

			<FormField
				control={control}
				name="description"
				render={({ field }) => (
					<FormItem>
						<FormLabel>รายละเอียด</FormLabel>
						<FormControl>
							<Textarea
								{...field}
								placeholder="รายละเอียดของรายการนี้"
								rows={2}
							/>
						</FormControl>
						<FormMessage />
					</FormItem>
				)}
			/>
		</>
	)
}
